/*
This solves an issue where JSON.stringify strips escape charactors from strings.
We require the string "\/Date(xxxxxxxxxx)\/" as the body of an API call
*/
export default function(obj: { [key: string]: string }) {
  const output: string[] = [];
  Object.keys(obj).forEach((key: string) => {
    output.push(`"${key}": "${obj[key]}"`);
  });
  return `{${output.join(',')}}`;
}
